<template>
	<div id="loginForm" class="screenSize remote">
		<header>
				<img src="@/assets/images/logo_remote.png" alt="logo remote">
		</header>
		<div id="orientation">
			<form>
				<h2>Merci de repasser en mode portrait</h2>
				<img src="../assets/images/landscape_lock.svg">
			</form>
		</div>
		<img class="backgroundBottom" id="background_last" src="@/assets/images/bottom_background_remote_1.svg" alt="Background bottom">
		<main id="index">
			<form>
				<h2>Connexion</h2>
				<p class="message">{{loginMessage}}</p>
				<div class="container">
					<input type="text" id="company" placeholder="Nom de votre société" v-model="client">
					<div class="icon company"></div>
				</div>
				<div class="container">
					<input type="password" placeholder="Mot de passe" v-model="token">
					<div class="icon password"></div>
				</div>
				<button v-bind:class="isActive ? 'selected' : ''" v-on:click.self.stop.prevent="sendLoginForm">Se connecter</button>
			</form>
			<div id="background-remote">
				<img src="@/assets/images/top_background_remote_1.svg" alt="Background top">
				<img src="@/assets/images/bottom_background_remote_1.svg" alt="Background bottom">
			</div>
		</main>
	</div>
</template>

<script>
export default {
	name: 'RemoteLoginForm',
	data() {
		return {
			client : '',
			token : '',
			loginMessage : ''
		};
	},
	props : ['api'],
	computed : {
		isActive : function(){
			return this.client.length && this.token.length;
		}
	},
	methods : {
		sendLoginForm : function(){
			let self = this;
			self.api.login(self.client, self.token)
			.then(token => {
				localStorage.setItem("Bearer", token);
				localStorage.setItem("client", self.client);
				return self.api.conf();
			}).then(conf => {
				localStorage.setItem("RemoteConf", JSON.stringify(conf));
				self.$router.push({ name : 'newEvent' });
			}).catch(err => {
				console.log(err.message);
				let message = "Identification impossible";
				if(err.message) message += ' / '+err.message;
				self.loginMessage = message;
			});
		}
	},
	created : function(){
		let token = localStorage.getItem("Bearer"), config = localStorage.getItem("RemoteConf"), client = localStorage.getItem("client");
		if(typeof(token) == "string" && token.length && typeof(config) == "string" && config.length && typeof(client) == 'string' && client.length) this.$router.push({ name : 'newEvent' });
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
@import '../assets/less/remote.less';

#index form{
	max-width: 500px;
}
#index input{
	display: block;
	position: relative;
	width: 100%;
}
#index .container {
	position: relative;
	width: 90%;
	left: 50%;
	transform: translateX(-50%);
	&:first-of-type{
		margin-top: 15%;
		margin-bottom: 10px;
	}
	&:last-of-type{
		margin-bottom: 15%;
	}
}
#index button {
	min-width: 60%;
}
#index input:focus + .icon,
#index input:not(:placeholder-shown) + .icon {
	background-color: @cGrey;
}
#index .icon {
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	background: @cGrey_Light_1;
}
@media screen
and (min-width: 1025px){
	#index form{
		width: 65%;
	}
}
@media screen
and (max-width: 1024px)
and (min-width: 481px){
	#index form{
		width: 65%;
		padding: 4%;
	}
	#index .container {
		width: 80%;
	}
}
@media screen 
and (max-width: 480px){	
	#index form{
		max-width: 90%;
		padding: 5%;
	}
	#index .container {
		&:first-of-type{
			margin-top: 10%;
			margin-bottom: 10px;
		}
		&:last-of-type{
			margin-bottom: 10%;
		}
	}
}
@media screen
	and (max-width: 860px)
	and (max-height: 550px){
		#index .container {
			&:first-of-type{
				margin-top: 10px;
				margin-bottom: 10px;
			}
			&:last-of-type{
				margin-bottom: 10px;
			}
		}
	}
p.message {
	&:extend(.centerBlock all);
	text-align : 'center';
}
</style>



// WEBPACK FOOTER //
// src/components/RemoteLoginForm.vue